import { Link } from "react-router-dom";

export default function AffiliateNote({ className = "", testId = "affiliate-note" }) {
  return (
    <p className={`font-mono text-[10px] uppercase tracking-widest opacity-70 ${className}`} data-testid={testId}>
      We may earn a commission at no extra cost to you ·{" "}
      <Link to="/page/affiliate-disclosure" className="underline hover:opacity-100">Disclosure</Link>
    </p>
  );
}
